
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 800 800","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M400 688c163.475 0 296-132.525 296-296 0-163.476-132.525-296-296-296-163.476 0-296 132.524-296 296 0 163.475 132.524 296 296 296z","stroke":"#fff","stroke-width":"48","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M429.789 260.802a29.452 29.452 0 01-8.96 20.517 29.45 29.45 0 01-20.803 8.282 28.796 28.796 0 01-25.911-18.428 28.774 28.774 0 01-1.251-16.557 28.8 28.8 0 0156.925 6.186zm-52.48 268.161v-172.16a22.364 22.364 0 016.441-16.371 22.387 22.387 0 0116.276-6.672 22.027 22.027 0 018.678 1.77 22.073 22.073 0 0112.006 12.524 22.041 22.041 0 011.396 8.749v172.16c0 2.941-.58 5.853-1.703 8.57a22.416 22.416 0 01-12.121 12.121 22.392 22.392 0 01-17.146 0 22.407 22.407 0 01-7.267-4.854 22.36 22.36 0 01-4.854-7.267 22.366 22.366 0 01-1.706-8.57z","fill":"#fff"}})])
          )
        }
      }
    